import {isObject} from 'utils';

const validateAddress = info => {
    if (isObject(info) && Object.keys(info).length) {
        const addressFields = Object.keys(info).filter(key =>
            key.includes('address')
        );

        if (addressFields.length) {
            return addressFields.every(key => info[key]);
        } else return false;
    } else {
        return false;
    }
};

export default validateAddress;
